import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
const rootPath = 'typetravaux';





class TypeTravauxService {
    // public getTableUrl(): string {
    //     return `${apiProvider.getUrl()}${rootPath}${toUrl({lang: lang})}`;
    // }

    public async listTypeTravaux(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }
    public async getTypeTravauxByKey(typeTravauxKey:string,lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/${typeTravauxKey}${buildQuery({lang})}`);
    }

    // public addSite(data: any): AxiosPromise {
    //     return apiProvider.put(`${rootPath}/${data.site.id}${toUrl({lang: lang})}`, data);
    // }
}

export default new TypeTravauxService();